import { render } from "./CommissionCharges.vue?vue&type=template&id=add265ee"
import script from "./CommissionCharges.vue?vue&type=script&lang=js"
export * from "./CommissionCharges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__